import { Reveal, Overline } from "./Reveal";
import { METHOD } from "../../lib/content";

export const Method = () => (
  <section id="metodo" className="relative py-24 md:py-36 scroll-mt-20" data-testid="method-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid md:grid-cols-12 gap-10 items-end">
        <Reveal className="md:col-span-8">
          <Overline>{METHOD.overline}</Overline>
          <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight">
            {METHOD.title}
          </h2>
        </Reveal>
        <Reveal className="md:col-span-4">
          <p className="text-white/55 text-lg md:text-right">{METHOD.subtitle}</p>
        </Reveal>
      </div>

      <div className="mt-16 divide-y divide-white/10 border-t border-white/10">
        {METHOD.steps.map((step, i) => (
          <Reveal key={step.n} delay={i * 0.06}>
            <div className="group grid md:grid-cols-12 gap-6 py-10 items-baseline hover:bg-white/[0.02] transition-colors duration-300 px-2 -mx-2 rounded-2xl">
              <div className="md:col-span-2 font-display text-6xl md:text-7xl font-extrabold text-bf-yellow leading-none">
                {step.n}
              </div>
              <h3 className="md:col-span-4 font-display text-2xl md:text-3xl font-bold tracking-tight">
                {step.title}
              </h3>
              <p className="md:col-span-6 text-white/60 text-lg leading-relaxed">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
